import {
  Row,
  Col,
  Input,
  Modal,
  Pagination,
  Button,
  Dropdown,
  Icon,
  Form,
  message,
  Checkbox
} from "antd";
import WeaFormItem from "../../wea-form-item";
import cloneDeep from "lodash/cloneDeep";
import forEach from "lodash/forEach";
import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import isEqual from "lodash/isEqual";

import WeaInputSearch from "../../wea-input-search";
import WeaSearchBrowserBox from "../wea-search-browser-box";
import WeaAssociativeSearchMult from "../wea-associative-search-mult";
import WeaTools from "../../wea-tools";
import Thumbnail from "./thumbnail";
import WeaSearchAdvance from "../../wea-search-advance";
import WeaLocaleProvider from "../../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

const initialState = {
  showSearchAd: false,
  count: 0,
  visible: false,
  currentPage: 1,
  inputValue: "",
  searchPara: {},
  browserConditions: [],
  showSelected: false,
  thumbnails: []
};

class Main extends React.Component {
  static defaultProps = {
    mult: true
  };
  constructor(props) {
    super(props);
    this.state = {
      visible: null,
      initialShowSearchAd: false,
      showSearchAd: false,
      isClearData: false,
      selectedData: {}, // 搜索按钮选中的数据
      currentPage: 1,
      pageSize: 20,
      count: 0,
      url: props.dataUrl,
      inputValue: "",
      searchPara: {},
      dataKey: "",
      browserConditions: [],
      contentType: 1, // 数据展示的类别
      quickSearch: "",
      hiddenIds: "",
      thumbnails: [],
      ctrIds: [], //check id受控
      ctrDatas: [],
      selectedValues: [],
      showSelected: false
    };
  }
  componentDidMount() {
    // 默认显示数据
    if (!isEmpty(this.props.replaceDatas)) {
      this.replaceSearchValues(this.props.replaceDatas);
    }
    if (!isEmpty(this.props.valueObj)) {
      this.replaceSearchValues(this.props.valueObj);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      "value" in nextProps &&
      this.props.value !== nextProps.value &&
      isEmpty(nextProps.value)
    ) {
      this.setState({ isClearData: !this.state.isClearData });
      this.handleClear();
    }
    if (
      "replaceDatas" in nextProps &&
      !isEqual(this.props.replaceDatas, nextProps.replaceDatas)
    ) {
      this.replaceSearchValues(nextProps.replaceDatas);
    }
    if ("valueObj" in nextProps && nextProps.valueObj) {
      this.replaceSearchValues(nextProps.valueObj || []);
    }
  }
  formatData(data) {
    if (data) {
      data.browser &&
        data.browser.forEach((b, idx) => {
          b.id = data.datas[idx].id;
          b.name = data.datas[idx].name;
          b.namespan = data.datas[idx].namespan;
          b.subcompanyid = data.datas[idx].subcompanyid;
          b.subcompanyidspan = data.datas[idx].subcompanyidspan;
          b.roomdesc = data.datas[idx].roomdesc;
          b.roomdescspan = data.datas[idx].roomdescspan;
          b.roomstatus = data.datas[idx].roomstatus;
          b.roomstatusspan = data.datas[idx].roomstatusspan;
        });
    }
  }
  datakeyTodatas(newDataKey, newCurrent, min, max, cb) {
    WeaTools.callApi("/api/ec/dev/table/datas", "POST", {
      dataKey: newDataKey,
      pageSize: this.state.pageSize,
      min: min,
      max: max
    })
      .then(
        data => {
          if (cb) cb();
          this.formatData(data);
          this.setState({
            thumbnails: data.browser
          });
        },
        e => {
          console.log("api /api/ec/dev/table/datas error", e);
        }
      )
      .catch(e => this.props.onError && this.props.onError(e)),
      WeaTools.callApi("/api/ec/dev/table/counts", "POST", {
        dataKey: newDataKey
      })
        .then(
          data => {
            this.setState({
              count: data.count
            });
          },
          e => {
            console.log("api /api/ec/dev/table/counts error", e);
          }
        )
        .catch(e => this.props.onError && this.props.onError(e));
  }
  formatUrl(url, params) {
    if (url && !isEmpty(params)) {
      url = `${url}${WeaTools.getFd(params)}`;
    }
    return url;
  }
  getData(url, currentPage, hasPagination = false, searchPara, cb) {
    const { pageSize, count } = this.state;
    url = url || this.state.url;
    let params = searchPara || this.state.searchPara || {};
    params = { ...params };
    currentPage = currentPage || this.state.currentPage;
    if (hasPagination) {
      params["min"] = (currentPage - 1) * pageSize + 1;
      params["max"] = currentPage * pageSize;
    }
    if (params["max"] && currentPage > 1) {
      if (params["max"] > count) params["max"] = count;
    }
    WeaTools.callApi(this.formatUrl(url, params), "GET")
      .then(data => {
        if (data.type == 1) {
          //分页table
          const dataKey = data.datas;
          this.setState(
            {
              contentType: data.type
              // pageSize: data.pageSize || 20
            },
            () => {
              this.datakeyTodatas(
                dataKey,
                currentPage,
                params["min"],
                params["max"],
                cb
              );
            }
          );
        }
      })
      .catch(error => {
        message.err(error);
        if (this.props.onError) this.props.onError(error);
      });
  }
  onPageChange(page) {
    this.getData("", page, true);
    this.setState({ currentPage: page });
  }
  closeModal() {
    this.setState({ visible: false });
  }
  openModal() {
    this.onCustomClick();
  }
  onSearchChange(v) {
    const { tabs } = this.props;
    const quickSearch = this.state.quickSearch || "name";
    const { dataUrl } = this.props;
    const { setFieldsValue } = this.props.form;
    let params = {};
    params[quickSearch] = v;
    if (!isEmpty(tabs) && !isEmpty(tabs[0].dataParams)) {
      params = { ...params, ...tabs[0].dataParams };
    }
    this.getData(dataUrl, 1, true, params); // 搜索获取数据
    setFieldsValue(params); // 高级搜索数据联动
    this.setState({
      url: dataUrl,
      inputValue: v,
      showSearchAd: false,
      searchPara: params
    });
  }
  goSearch = e => {
    const { tabs } = this.props;
    const quickSearch = this.state.quickSearch || "name";
    const { dataUrl } = this.props;
    e.preventDefault();
    const { validateFields } = this.props.form;
    let params = {};
    validateFields((errors, object) => {
      if (!!errors) {
        message.error("Errors in form!!!");
        return;
      }
      let newObject = cloneDeep({ ...object, ...conditionParamsBK });
      forEach(newObject, (value, key) => {
        if (value) params[key] = value;
      });
    });
    if (!isEmpty(tabs) && !isEmpty(tabs[0].dataParams)) {
      params = { ...params, ...tabs[0].dataParams };
    }
    this.getData(dataUrl, 1, true, params); // 搜索获取数据
    this.setState({
      url: dataUrl,
      searchPara: params,
      showSearchAd: false,
      inputValue: params[quickSearch] || ""
    });
  };
  showModal() {
    this.setState({ visible: true });
  }

  setShowSearchAd(bool) {
    const { showSearchAd } = this.state;
    this.setState({ showSearchAd: bool, initialShowSearchAd: true });
  }
  onCustomClick = e => {
    e && e.preventDefault();
    if (this.props.onBeforeFocusCheck) {
      let cb = this.onCustomClickInner.bind(this);
      this.props.onBeforeFocusCheck(cb);
    } else {
      this.onCustomClickInner(e);
    }
  };
  onCustomClickInner = e => {
    this.onBrowerClick();
  };
  onBrowerClick = (keys, selectedObj) => {
    const { resetFields, setFieldsValue } = this.props.form;
    resetFields(); // 重置高级搜索
    const { tabs, dataUrl } = this.props;
    let url = dataUrl;
    this.onBrowerChange(keys, selectedObj, false);
    const { conditionURL } = this.props;
    WeaTools.callApi(conditionURL, "GET").then(data => {
      let quickSearch;
      if (!isEmpty(data.conditions)) {
        data.conditions.forEach(item => {
          if (item.isQuickSearch) {
            quickSearch = item.domkey[0];
          }
        });
      }
      const params = WeaTools.getParamsByConditions(data.conditions);
      conditionParamsBK = params;
      setFieldsValue(params);
      this.browserConditionsBk = data.conditions;
      this.defaultConditionParams = { ...params };
      this.setState({
        browserConditions: data.conditions,
        quickSearch,
        url,
        searchPara: params,
        inputValue: params[quickSearch] || ""
      });
      this.getData(url, 1, true, params);
    });
    this.showModal();
  };
  onBrowerChange(values, datas, needOnchange = true) {
    const { destUrl } = this.props;
    if (!isEmpty(values)) {
      values = uniq(values);
      WeaTools.callApi(`${destUrl}selectids=${values.join(",")}`, "GET").then(
        res => {
          this.formatData(res);
          this.setState({
            ctrIds: values,
            ctrDatas: res.browser || []
          });
          if (needOnchange)
            this.throwCurrentState(values.join(","), res.browser || []);
        },
        e => {
          console.log("api /api/public/browser/destData error", e);
        }
      );
    } else {
      this.setState({ ctrIds: [], ctrDatas: [] });
      if (needOnchange) this.throwCurrentState("", []);
    }
  }
  handleOk() {
    const { ctrIds, ctrDatas = [] } = this.state;
    let selectedData = {};
    ctrDatas.forEach(c => (selectedData[c.id] = c));
    this.setState({
      selectedValues: [...ctrIds],
      selectedData: selectedData,
      visible: false
    });
    this.throwCurrentState(ctrIds.join(","), ctrDatas);
    this.setState(initialState); //初始化浏览框
  }
  handleCancel() {
    this.setState(initialState); //初始化浏览框
  }
  handleClear() {
    this.setState({
      visible: false,
      isClearData: !this.state.isClearData,
      selectedData: {},
      selectedValues: []
    });
    this.setState(initialState); //初始化浏览框
    this.throwCurrentState("", []);
  }
  replaceSearchValues(datas = []) {
    let ids = [],
      selectedData = {};
    datas.forEach(item => {
      ids.push(item.id);
      selectedData[item.id] = item;
    });
    this.setState({ selectedValues: ids, selectedData: selectedData });
  }
  toArr(values, datas) {
    let arr = [];
    for (let i = 0; i < values.length; i++) {
      arr.push(datas[values[i]]);
    }
    return arr;
  }
  onBrowerChangeHandler(values, datas) {
    const throwDatas = this.toArr(values, datas);
    this.setState({
      selectedObj: values,
      selectedValues: values,
      selectedData: datas
    });
    this.throwCurrentState(values.join(","), throwDatas);
  }
  count(ctrIds = [], rNum = false) {
    let count = 0;
    count += uniq(ctrIds).length;
    if (rNum) return count;
    return count > 0 ? `(${count})` : "";
  }

  thumbnailsOnCheck(ids = [], datas = []) {
    let { ctrDatas = [] } = this.state;
    Array.prototype.push.apply(ctrDatas, datas);
    ctrDatas = uniqBy(ctrDatas, "id");
    ctrDatas = ctrDatas.filter(c => ids.indexOf(c.id) > -1);
    this.setState({
      ctrIds: ids,
      ctrDatas: ctrDatas
    });
  }

  onAdvanceSearchEnter = e => {
    const event = window.event || e;
    const target = event.target;
    const keyCode = event.keyCode || event.which || event.charCode;
    if (keyCode == 13 && target && target.nodeName == "INPUT" && target.id) {
      this.goSearch(e);
    }
  };

  render() {
    const {
      icon,
      iconBgcolor,
      title,
      browerType,
      dataUrl,
      min,
      max,
      fieldName,
      contentHeight,
      modalStyle
    } = this.props;
    const {
      id,
      name,
      style,
      isMult,
      disabled,
      value,
      type,
      mult,
      customized
    } = this.props;
    const {
      visible,
      showSearchAd,
      inputValue,
      pageSize,
      count,
      currentPage
    } = this.state;
    const { displayType, selectedData, ctrIds, ctrDatas } = this.state;
    const { contentType, treeData, hiddenIds } = this.state;
    const { state, props } = this;
    let titleEle = (
      <Row>
        <Col span="8" style={{ paddingLeft: 20, lineHeight: "48px" }}>
          <div className="wea-hr-muti-input-title">
            {iconBgcolor ? (
              <div
                className="wea-workflow-radio-icon-circle"
                style={{ background: iconBgcolor ? iconBgcolor : "" }}
              >
                <i className={icon} />
              </div>
            ) : (
              <span style={{ verticalAlign: "middle", marginRight: 10 }}>
                <i className={icon} />
              </span>
            )}
            <span style={{ verticalAlign: "middle" }}>{title}</span>
          </div>
        </Col>
      </Row>
    );
    let inputArr = (
      <WeaAssociativeSearchMult
        {...this.props}
        style={this.props.inputStyle}
        datas={state.selectedData}
        selectedValues={state.selectedValues}
        isClearData={state.isClearData}
        type={type}
        clickCallback={this.onBrowerClick}
        onChange={this.onBrowerChangeHandler.bind(this)}
      />
    );
    const buttons = [
      <Button
        key="submit"
        type="primary"
        onClick={this.handleOk.bind(this)}
        disabled={this.count(ctrIds, true) == 0}
      >
        {getLabel(385565, "确 定")}
        {this.count(ctrIds)}
      </Button>,
      <Button key="clear" type="ghost" onClick={this.handleClear.bind(this)}>
        {getLabel(385566, "清 除")}
      </Button>,
      <Button key="back" type="ghost" onClick={this.handleCancel.bind(this)}>
        {getLabel(385567, "取 消")}
      </Button>
    ];
    const searchsBox = this.getSearchs();
    const buttonsAd = this.getTabButtonsAd();
    let initHeight = contentHeight;
    let sheight = initHeight;
    if (contentType === 1 || contentType === 4) sheight -= 35; //显示分页
    const { dataKey } = this.state;
    let dom = inputArr;
    if (customized) {
      dom = (
        <div className="cursor-pointer" onClick={this.onCustomClick}>
          {this.props.children}
        </div>
      );
    }
    const browserPagination = (
      <Pagination
        weaSimple
        showTotal={total => getLabel(385617, "共$s条").replace(/\$s/, total)}
        total={count}
        pageSize={pageSize}
        current={currentPage}
        onChange={this.onPageChange.bind(this)}
      />
    );
    return (
      <div>
        {dom}
        {this.props.extraElement}
        <input
          type="hidden"
          id={fieldName}
          name={fieldName}
          value={hiddenIds}
        />
        <Modal
          wrapClassName="wea-hr-muti-input wea-browser-thumbnails wea-browser-modal"
          title={titleEle}
          width={modalStyle.width}
          maskClosable={false}
          visible={visible}
          onCancel={this.handleCancel.bind(this)}
          footer={buttons}
        >
          <div className="wea-thumbnails">
            <span>
              <WeaSearchAdvance
                leftDom={
                  <span className="wea-thumbnail-filter">
                    <Checkbox
                      checked={this.state.showSelected}
                      onChange={() =>
                        this.setState({
                          showSelected: !this.state.showSelected
                        })
                      }
                    >
                      {getLabel(385596, "仅显示已选")}
                    </Checkbox>
                  </span>
                }
                buttonsAd={buttonsAd}
                searchType={["base", "advanced"]}
                searchsBaseValue={inputValue}
                searchsAd={<Form horizontal>{searchsBox}</Form>}
                showSearchAd={showSearchAd}
                setShowSearchAd={bool => {
                  this.setShowSearchAd(bool);
                }}
                onSearchChange={v => this.setState({ inputValue: v })}
                onSearch={this.onSearchChange.bind(this)}
              />
            </span>
            <Thumbnail
              {...this.props}
              sheight={sheight}
              browser={!state.showSelected ? state.thumbnails : state.ctrDatas}
              ctrIds={uniq(state.ctrIds)}
              thumbnailsOnCheck={this.thumbnailsOnCheck.bind(this)}
            />
            {!state.showSelected && browserPagination}
          </div>
        </Modal>
      </div>
    );
  }
  throwCurrentState(ids, datas = []) {
    ids = uniq(ids.split(",")).join(",");
    this.setState({ hiddenIds: ids });
    let names = [];
    datas.forEach(d => {
      names.push(d.name);
    });
    this.props.onChange && this.props.onChange(ids, names.join(","), datas);
  }

  getSearchs() {
    const { browserConditions } = this.state;
    let items = [];
    !isEmpty(browserConditions) &&
      browserConditions.forEach(field => {
        items.push({
          com: (
            <WeaFormItem
              label={`${field.label}`}
              labelCol={{ span: `${field.labelcol}` }}
              wrapperCol={{ span: `${field.fieldcol}` }}
            >
              {WeaTools.getComponent(
                field.conditionType,
                field.browserConditionParam,
                field.domkey,
                this.props,
                field
              )}
            </WeaFormItem>
          ),
          colSpan: 2
        });
      });
    return (
      <WeaSearchBrowserBox
        items={items}
        onKeyDown={this.onAdvanceSearchEnter}
      />
    );
  }

  getTabButtonsAd() {
    let _this = this;
    const { resetFields, validateFields } = this.props.form;
    return [
      <Button
        type="primary"
        onClick={e => {
          this.goSearch(e);
        }}
      >
        {getLabel(197, "搜索")}
      </Button>,
      <Button
        type="ghost"
        onClick={e => {
          e.preventDefault();
          this.setState({ inputValue: "" });
          resetFields();
        }}
      >
        {getLabel(2022, "重置")}
      </Button>,
      <Button
        type="ghost"
        onClick={() => {
          _this.setState({ showSearchAd: false });
        }}
      >
        {getLabel(31129, "取消")}
      </Button>
    ];
  }
}

let conditionParamsBK = {};
Main = Form.create({
  onFieldsChange(props, fields) {
    for (let key in fields) {
      conditionParamsBK[fields[key].name] = fields[key].value;
    }
  }
})(Main);
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-thumbnail/index.js